import { render, staticRenderFns } from "./Psalms.vue?vue&type=template&id=8f579c30&scoped=true&"
import script from "./Psalms.vue?vue&type=script&lang=js&"
export * from "./Psalms.vue?vue&type=script&lang=js&"
import style0 from "./Psalms.vue?vue&type=style&index=0&id=8f579c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f579c30",
  null
  
)

export default component.exports